import { Skeleton } from '@mui/material'
import { liveChatSkeletonStyle as styles } from './liveChatSkeleton.tailwind'

const LiveChatSkeleton = () => {
    return (
        <div className={styles.outerContainer}>
            <div className={styles.chatContainer}>
                <Skeleton variant='circular' width={30} height={30} sx={{ bgcolor: 'var(--themeOverlay)' }} />
                <div className={styles.messageContainer} />
            </div>
            <div className={styles.chatContainer}>
                <Skeleton variant='circular' width={30} height={30} sx={{ bgcolor: 'var(--themeOverlay)' }} />
                <div className={styles.messageContainer} />
            </div>
            <div className={styles.chatContainer}>
                <Skeleton variant='circular' width={30} height={30} sx={{ bgcolor: 'var(--themeOverlay)' }} />
                <div className={styles.imageContainer} />
            </div>
        </div>
    )
}

export default LiveChatSkeleton